import JQuery from "jquery";
import Bugsnag from "@bugsnag/js";

export default class CSkippyToast {
  private static skippyToasts: Map<string, JQuery<HTMLElement>>;
  private static displayedToast: JQuery<HTMLElement> = null;
  private static displayedId: string = null;
  private static closeTimeout: number;
  private static currentTrigger: JQuery<HTMLElement> = null;

  public static GetToastTarget(id: string): JQuery<HTMLElement> {
    return this.skippyToasts.get(id);
  }

  public static Add(id: string, trigger: JQuery<HTMLElement> = null): void {
    if (this.skippyToasts === undefined) {
      this.init();
    }
    if (this.skippyToasts.has(id)) {
      return;
    }
    const target = $(`#${id}`);
    const closeButtons = target.find(".js-skippy-toast-close");

    if (target.length === 0) {
      console.debug(`Skippy toast with id ${id} not found`);
      Bugsnag.notify(`Skippy toast with id ${id} not found`);
      return;
    }

    if (trigger) {
      trigger.on("click", () => {
        this.Show(id, trigger);
      });
    }
    closeButtons.on("click", () => this.close());

    this.skippyToasts.set(id, target);
  }

  public static Show(id: string, trigger: JQuery<HTMLElement> = null): void {
    if (this.skippyToasts === undefined) {
      this.init();
    }
    if (!this.skippyToasts.has(id)) {
      this.Add(id, trigger);
    }
    const target = this.skippyToasts.get(id);
    const duration = +target.data("duration");

    // If the toast is already displayed, reset the timeout
    if (this.displayedId === id) {
      clearTimeout(this.closeTimeout);
      this.setCloseTimeout(duration);
      return;
    }

    // If another toast is displayed, close it and show the new one after the transition
    if (this.displayedToast) {
      this.showAfterTransition(id, trigger);
      return;
    }

    this.displayedToast = target;
    this.displayedId = id;
    this.currentTrigger = trigger;

    clearTimeout(this.closeTimeout);
    target.trigger("focus");
    target.removeClass("skippy-toast-closed");
    clearTimeout(this.closeTimeout);
    this.setCloseTimeout(duration);
  }

  private static init(): void {
    this.skippyToasts = new Map<string, JQuery<HTMLElement>>();
    this.displayedToast = null;

    // When an animation is done, remove the toast from the DOM
    $(".js-skippy-toast").on("transitionend", () => {
      if (this.displayedToast?.hasClass("skippy-toast-closed")) {
        this.remove();
      }
    });

    // If click outside a text-container, hide the toast
    $(".main-container").on("click.skippy-toast", (event) => {
      if (!CSkippyToast.displayedToast) {
        return;
      }
      // Do not hide if the element clicked is the toast itself or the element that triggered it
      if (
        event.target.closest(".skippy-toast-container") ||
        this.currentTrigger?.find(event.target).length > 0
      ) {
        return;
      }

      if (event.target instanceof HTMLAnchorElement) {
        return;
      }
      this.close();
    });
  }

  /**
   * Add the close animation to the toast.
   * When the animation is done, the toast is removed from the DOM.
   * @private
   */
  private static close(): void {
    this.displayedToast.addClass("skippy-toast-closed");
  }

  /**
   * Reset the variables to their initial state
   * @private
   */
  private static remove(): void {
    this.displayedToast.off("transitionend.hide-toast");
    this.displayedToast.removeClass("close-fast");
    this.displayedToast = null;
    this.displayedId = null;
    this.currentTrigger = null;
    clearTimeout(this.closeTimeout);
  }

  /**
   * Close the current toast and show the new one after the transition is done
   * @param id
   * @param trigger
   * @private
   */
  private static showAfterTransition(
    id: string,
    trigger: JQuery<HTMLElement> | null,
  ): void {
    this.displayedToast.addClass("close-fast");
    this.displayedToast.addClass("skippy-toast-closed");
    this.displayedToast.on("transitionend.hide-toast", () => {
      this.Show(id, trigger);
    });
  }

  private static setCloseTimeout(duration: number): void {
    if (duration <= 0) {
      return;
    }
    this.closeTimeout = window.setTimeout(() => {
      this.close();
    }, duration);
  }
}
